import React, {useEffect, useState} from "react";
import Box from "../../lib/appfuse-react/component/Box";
import Paper from "../../lib/appfuse-react/component/Paper";
import DataTable, {DataColumn} from "../../lib/appfuse-react/component/DataTable";
import DataPagination from "../../lib/appfuse-react/component/DataPagination";
import courseBriefService from "../../service/courseBrief/courseBriefService";
import CircularProgress from "../../lib/appfuse-react/component/CircularProgress";
import time from "../../lib/appfuse-react/core/time";
import lang from "../../lib/appfuse-react/core/lang";
import downloader from "../../lib/appfuse-react/core/downloader";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import {useSelector} from "../../store";
import {isAuthenticated} from "../../reducer/iam/authReducer";
import {withDesktop} from "../../layout/Desktop";
import {withExplorer} from "../../layout/Explorer";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";
import {Divider, Typography} from "@material-ui/core";
import Button from "../../lib/appfuse-react/component/Button";
import {CloudDownload} from "@material-ui/icons";

function MobileCourseInfo(props) {
    const {title ='', createdOn = '', brief = ''} = props;

    return (
        <Box display={'flex'} flexDirection={'column'} gap={1} marginY={2}>
            <Typography variant='h6'>{`${title}`}</Typography>
            <Typography variant='h6'>{`公告日期：${time.format(createdOn, 'date')}`}</Typography>
            <Button startIcon={<CloudDownload/>} onClick={() => downloader.save(brief)} variant={'contained'} fullWidth color={'primary'}>下載</Button>
            <Divider/>
        </Box>
    )
}

function CourseBriefContent() {
    const prompt = usePrompt();
    const [ready, setReady] = useState(false);
    const [value, setValue] = useState([]);
    const [selection, setSelection] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const count = value?.totalElements || 0;

    useEffect(() => {
        (async () => {
            const data = await courseBriefService.find({page:pageNumber, size:pageSize});
            setValue(data);
            setReady(true);
        })();
    }, []);

    const handleChangePageNumber = event => setPageNumber(event.pageNumber);
    const handleChangePageSize = event => setPageSize(event.pageSize);

    const briefRender = ({brief}) => {
        if(lang.isEmpty(brief)) return null;
        else return <CloudDownload/>;
    };
    const handleDownloadBrief = async (brief) => {
        try {
            await downloader.save(brief);
            prompt.success('Download successfully.');
        } catch (e) {
            prompt.alert(e, {title:'Failed to download.'});
        }
    };

    const handleSelection = (rowId) => {
        if(lang.first(selection)===rowId) setSelection([]);
        else setSelection([rowId]);
    };
    const handleCellClick = async ({rowId, col, value}) => {
        if(col===2 && value) {
            await handleDownloadBrief(value);
        } else {
            handleSelection(rowId);
        }
    };

    const responsive = useResponsive();
    const isMobile = responsive.isSmallScreen() || responsive.isMediumScreen();

    const mobileInfos = value.map((item, index) => {
        const {uuid, title, createdOn, brief} = item;
        return <MobileCourseInfo key={uuid} title={title} createdOn={createdOn} brief={brief}/>
    });

    return (
        <Box fullHeight fullWidth overflow='hidden'>
            <CircularProgress value={ready} fullWidth fullHeight backgroundColor='white'>
                <Paper fullWidth fullHeight square variant='outlined'>
                    <Box fullHeight fullWidth display='flex' flexDirection='column' padding={2}>
                        <Box paddingX={isMobile?0:2} paddingTop={2} fullWidth overflow="hidden">
                            {isMobile ? mobileInfos :
                                <DataTable data={value} selection={selection} onSelect={handleSelection}
                                        pageSize={pageSize} pageNumber={pageNumber} onCellClick={handleCellClick}
                                        rowId='uuid' stickyHeader maxHeight='100%'>
                                <DataColumn accessor='title' label="Title"/>
                                <DataColumn accessor='createdOn' label='Announcement Date' formatter={time}
                                            pattern='date'/>
                                <DataColumn accessor='brief' label='Download' renderer={briefRender}/>
                            </DataTable>}
                        </Box>
                        <Box paddingX={isMobile?0:2}>
                            <DataPagination count={count} pageSize={pageSize} pageNumber={pageNumber} onChangePageNumber={handleChangePageNumber} onChangePageSize={handleChangePageSize}/>
                        </Box>
                    </Box>
                </Paper>
            </CircularProgress>
        </Box>
    );
}


function CourseBrief() {
    const authenticated = useSelector(isAuthenticated);

    return authenticated? withDesktop(CourseBriefContent)():withExplorer(CourseBriefContent)();
}

export default CourseBrief;